<template>
  <div class="mobile-wrapper" :class="isSushi && 'montserrat-500'">
    <div class="fixed-banner">
      <div class="container-fluid banner-alt" :style="getStyle()">
        <div class="row">
          <div class="col-12 banner-title">
            <span class="material-icons md-36" @click="goBack">keyboard_arrow_left</span>
            <span :class="isSushi ? 'montserrat-700' :  'title-text'"    @click="goBack">{{ $t('message.orderTracking') }}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="bg-white vform position-relative">
      <div class="row justify-content-center">
        <div class="col-lg-12 bg-white py-4">
          <div class="container mt-4 pt-4">
            <div v-for="(order, index) in pageOrders" :key="index" class="row">
              <tracking-component :order="order" :store="currentStoreDoc"></tracking-component>
              <div class="col-sm-12">
                <hr />
              </div>
            </div>
            <div v-if="pageOrders.length == 0">
              <message :message="getNoOrderAvailable" />
            </div>
          </div>
          <div class="text-center">
            <button
              v-if="orders.length != pageOrders.length"
              class="btn btn-info"
              :style="mobileStyles.btn"
              @click="moreCallback()"
            >{{$t("message.more")}}</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import common from "../../sharedscripts/Common/commonMobile";
import shared from "../../sharedscripts/user/orderTracking.js";
import Message from "./../shared/Message";
import TrackingComponent from "./partials/trackingComponent";
export default {
  components: {
    Message,
    TrackingComponent
  },

  data() {
    return {
      page: 2,
      perPage: 3,
      records: 0,
      options: {
        theme: "bootstrap4",
        chunksNavigation: "scroll",
        texts: {
          count: "",
          prev: "prev"
        }
      },
      orders: [],
      pageOrders: [],
      loading: false,
      error: "",
      success: false
    };
  },
  computed: {
    ...mapGetters(["user", "hqDoc", "currentstore", "mobileStyles", "currentStoreDoc"]),
    getNoOrderAvailable() {
      return this.$t("message.noOrderAvailable");
    },
    isSushi(){
    return this.hqDoc && this.hqDoc.IsSushiHub;
  }
  },
  watch: {
    user(newValue) {
      if (newValue) {
        this.initOrders(this.currentStoreDoc.ID);
      }
    }
  },
  created() {
    if (this.user) {
      this.initOrders(this.currentStoreDoc.ID);
    }
  },
  methods: {
    ...common.methods,
    ...shared.methods
  }
};
</script>

